import * as React from 'react'
import theme from 'theme'
import styled from 'styled-components'
import ArrowRight from 'assets/arrow-right.svg'

type Props = {
  click?: () => void
  lengthLabel?: string
  title?: string
  'data-cy-state'?: string
  'data-cy-handle'?: string
  'data-cy-state-label'?: string
  label: string
  asDiv?: boolean
}

export default function MoreOptionsArrow(props: Props) {
  return (
    <Wrapper className="MoreOptionsArrow">
      <IconWrapper
        as={props.asDiv ? 'div' : 'button'}
        aria-label={props.label}
        data-cy-state={props['data-cy-state']}
        data-cy-handle={props['data-cy-handle']}
        onClick={props.click}
        title={props.title}
      >
        <ArrowRight />
      </IconWrapper>
      {props.lengthLabel && (
        <div className="label" data-cy-state={props['data-cy-state-label']}>
          {props.lengthLabel}
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing('xxs')};
  > .label {
    ${theme.ty('rc-xs')}
    text-wrap: nowrap;
  }
`

const IconWrapper = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.375rem;
  height: 1.375rem;
  border: 1px solid black;
  border-radius: 0.1875rem;
  > svg {
    width: ${theme.spacing('xxs')};
  }
`
